import React from 'react'

import {
  AdminActionEnum,
  getContentAdminActionModal,
  getLabelAdminActionModal,
} from '../utils/admin-action-data'
import { Modal } from '../../../../../../molecules'

interface IAdminActionModalProps {
  isOpenModal: boolean
  setIsOpenModal: (isOpen: boolean) => void
  onClickConfirm: () => void
  isLoading: boolean
  adminAction: AdminActionEnum
}

const AdminActionModal = ({
  isOpenModal,
  setIsOpenModal,
  onClickConfirm,
  isLoading,
  adminAction,
}: IAdminActionModalProps) => {
  return (
    <Modal
      isOpen={isOpenModal}
      closeModal={() => setIsOpenModal(false)}
      title={getLabelAdminActionModal({ adminAction })}
      scrollbarStyle={{ padding: '0px 30px' }}
      footerStyle={{ boxSizing: 'border-box' }}
      className='h-[400px] w-[500px]'
      footer={{
        button: {
          label: getLabelAdminActionModal({ adminAction }),
          fullWidth: true,
          onClick: onClickConfirm,
          isLoading,
        },
      }}
    >
      <div className='mt-3 flex flex-col justify-center gap-4 text-[14px]'>
        {getContentAdminActionModal({ adminAction })}
      </div>
    </Modal>
  )
}

export default AdminActionModal
